import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { CommonModule, DatePipe } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { ConfirmDialogService, UiKitModule } from '@serviceplan/ui-kit';
import { AssetBasketService, DownloadAssetsService } from '@thehubz/client/asset-services';
import {
  AppSettings,
  AssetUIModel,
  AssetsGenerateUrlService,
  BackgroundProcessService,
  CanPipe,
  ClientCoreModule,
  ClientEnvironment,
  ClientNotificationHandlerService,
  CommonUtilityLib,
  ENVIRONMENT,
  FilterAllOptions,
  FilterBubbleDateLabel,
  FilterFormDataModel,
  NotificationService,
  ResizeService,
  SearchAssetsFieldPlaceholder,
  SpDateFormatPipe,
  TagsDataConfig,
  ViewType,
  accessAsset,
  anyAsset,
  anyGlobal,
} from '@thehubz/client/core';
import { Asset, AssetsApiService, ExportExcelRequest, ExportsApiService, TagsWithAssetCount } from '@thehubz/client/data-access-api';
import { CustomClients } from '@thehubz/shared/branding';
import { AnyType, AssetMetadata } from '@thehubz/shared/model';
import { EMPTY, Observable, Subject, Subscription, timer } from 'rxjs';
import { debounceTime, delay, switchMap, tap } from 'rxjs/operators';
import { customerAssetFilters } from '../../../customer/customer-asset-filters';
import { LufthansaTableColumnData } from '../../../customer/lufthansa/lufthansa-table-column-data';
import { AssetCommonService } from '../../../services/asset-common.service';
import { AssetFiltersService } from '../../../services/asset-filters.service';
import { AssetViewTypeService, GridConfig } from '../../../services/asset-view-type.service';
import { ProductBrandSelectionService } from '../../../services/product-brand-selection.service';
import { BuyoutUtilsService } from '../../asset-buyout-rights/buyout-utils.service';
import { AssetDeletionDialogComponent } from '../../asset-detail-view/asset-deletion-dialog/asset-deletion-dialog.component';
import { AssetDownloadComponent, AssetDownloadData } from '../../asset-download/asset-download.component';
import { AssetGalleryViewComponent } from '../../asset-gallery-view/asset-gallery-view.component';
import { AssetListViewComponent } from '../../asset-listview/asset-listview.component';
import { TagsDialogComponent } from '../../tags-dialog/tags-dialog.component';
import { AssetsActionsComponent } from '../assets-actions/assets-actions.component';
import { AssetsSidebarComponent } from '../assets-sidebar/assets-sidebar.component';
import { FilterFormData } from '../filter-form-data';
import { TableColumnData } from '../table-column-data';

@Component({
  selector: 'thehubz-assets-control',
  templateUrl: './assets-control.component.html',
  styleUrls: ['./assets-control.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatProgressSpinnerModule,
    ClientCoreModule,
    UiKitModule,
    AssetGalleryViewComponent,
    AssetListViewComponent,
    AssetsActionsComponent,
    AssetsSidebarComponent,
  ],
  providers: [ResizeService, ProductBrandSelectionService, DatePipe, SpDateFormatPipe],
})
export class AssetsControlComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('scroller') scroller!: CdkVirtualScrollViewport;
  @ViewChild(AssetGalleryViewComponent) assetGalleryView!: AssetGalleryViewComponent;
  @ViewChild(AssetListViewComponent) assetListView!: AssetListViewComponent;
  @ViewChild(AssetsSidebarComponent) assetSidebar?: AssetsSidebarComponent;

  @Input() configObject!: AnyType;
  @Input() removedCheckedAssets!: Observable<AssetUIModel>;
  @Input() projectFilterData!: Observable<{ client: string; brand: string }>;
  @Input() showFilterBubbles = true;
  @Input() excludedAssets?: string[] = [];
  @Input() assetChecked: AssetUIModel[] = [];
  @Input() gridSettingsKeySuffix = 'AssetUploadStepper';

  @Output() updateSelectedData = new EventEmitter<AssetUIModel[]>();
  @Output() selectedAssets = new EventEmitter<AssetUIModel[]>();

  /* Use formResetter when filter bubble is cleared */
  formResetter = new Subject<{ _id: string; name: string; key: string } | undefined>();

  itemSize = 310;
  scrollFlag = true;
  assetCount = 0;
  imageObject: AssetUIModel[] = [];
  /**
   * This 2d array is created for use with the cdkVirtualScroll
   */
  imageSplitObject!: AssetUIModel[][];

  dashboardFlag = false;
  projectFlag = false;
  loading = false;
  sortByNew = true;
  searchText = '';
  prefix = 'is-';
  size = 4;
  sizes = AppSettings.SCREEN_SIZES;
  selectedData: AssetUIModel[] = [];
  bannerImgHidden = false;
  initialFlag = true;
  imgHidden = false;
  modelChanged = new Subject<string>();
  offset = 0;
  selectedFilterObject: AnyType;
  queryStringObject: AnyType;
  tagsObj = {
    tags: [],
  };
  filterObject: FilterAllOptions = {
    filters: {},
    sort: {},
    limit: 48,
    skip: 0,
  };
  appliedFilters = 0;
  showUploadBtn = true;
  defaultSort: Record<string, number> = { createdAt: -1 };
  sortData: Record<string, number> = {};
  projectFilters!: AnyType;
  emptyStateParaText = '';
  showEmptyState = false;
  selectedViewType!: ViewType;
  selectedViewSection2: ViewType = 'sortByLastCreated';
  currentSize: AnyType;
  filterBubbles: { _id: string; name: string }[] = [];
  hideBulkEdit = false;
  assetUploadStepperFlag = false;
  enableAssetDetailsLink = false;
  skipFilterProperty: string[] = [];
  searchPlaceholder = SearchAssetsFieldPlaceholder;
  readonly brandingKey: CustomClients;

  Globally = anyGlobal;
  CustomClients = CustomClients;
  AccessAsset = accessAsset;
  AnyAsset = anyAsset;
  AssetType = Asset.AssetTypeEnum;
  filterAssetFormData!: FilterFormDataModel;
  tableColumnData = TableColumnData;

  private resizeSubscription?: Subscription;
  private projectFilterSubscription?: Subscription;
  private removedCheckedAssetsSubscription?: Subscription;
  private modelSub?: Subscription;
  private exportAssetInfoSub?: Subscription;

  dialogState?: number;
  dialogState2?: number;
  tagsDialogRef!: MatDialogRef<TagsDialogComponent, TagsWithAssetCount[]>;

  /**
   * True when data is loading from server
   */
  httpCallInProgress = false;
  isMobileSearchOpen = false;

  gridConfig: GridConfig = {
    showListView: false,
    showGridView: true,
    showGridViewSmall: true,
    showGridViewLarge: false,
    showGridViewSidebar: false,
  };

  constructor(
    @Inject(ENVIRONMENT) readonly env: ClientEnvironment,
    private canPipe: CanPipe,
    private dialog: MatDialog,
    private elementRef: ElementRef,
    private resizeSvc: ResizeService,
    private datePipe: DatePipe,
    private spDatePipe: SpDateFormatPipe,
    private assetService: AssetsApiService,
    private commonUtilityLib: CommonUtilityLib,
    private assetBasketService: AssetBasketService,
    private notificationsService: NotificationService,
    private assetCommonService: AssetCommonService,
    private assetUrlService: AssetsGenerateUrlService,
    private confirmDialog: ConfirmDialogService,
    private downloadAssetsService: DownloadAssetsService,
    private exportExcelApiService: ExportsApiService,
    private backgroundProcessService: BackgroundProcessService,
    private clientNotificationHandlerService: ClientNotificationHandlerService,
    private buyoutUtilsService: BuyoutUtilsService,
    private productBrandSelectionService: ProductBrandSelectionService,
    private assetFiltersService: AssetFiltersService,
    protected assetViewTypeService: AssetViewTypeService,
  ) {
    this.brandingKey = this.env.brandingKey;
    this.resizeSubscription = this.resizeSvc.onResize$.pipe(delay(0)).subscribe((x) => {
      const currentSize = this.sizes.find((x) => {
        const el = this.elementRef.nativeElement.querySelector(`.${this.prefix}${x.id}`);
        const isVisible = window.getComputedStyle(el).display != 'none';
        return isVisible;
      });
      this.currentSize = currentSize;
      if (!this.dashboardFlag || !this.projectFlag) {
        this.initAssetView();
        this.setAssetView(currentSize);
      }
      this.imageSplitObject = [];
      this.imageSplitObject = this.split(this.imageObject, this.size);
    });
    if (this.brandingKey === CustomClients.LufthansaMediacenter || this.brandingKey === CustomClients.LufthansaMedialounge) {
      this.tableColumnData = LufthansaTableColumnData;
    }
    this.modelSub = this.modelChanged.pipe(debounceTime(500)).subscribe(() => {
      this.searchTextFilter();
    });
  }

  @HostListener('window:resize', [])
  private onResize() {
    this.detectScreenSize();
  }

  ngAfterViewInit(): void {
    this.detectScreenSize();
  }

  /**
   * For createProject and createStepper, exclude client and brand from formFieldName for filter form Object
   */
  formDataFields() {
    if (this.filterAssetFormData) {
      if (this.configObject.callFrom === 'createProject' || this.configObject.callFrom === 'createStepper') {
        this.filterAssetFormData.formFields = this.filterAssetFormData.formFields.filter(
          (formField: AnyType) => formField.formFieldName !== 'client' && formField.formFieldName !== 'brand',
        );
      }
    }
  }

  ngOnInit(): void {
    this.assetUploadStepperFlag = false;
    if (this.configObject?.callFrom === 'assetUploadStepper') {
      this.assetUploadStepperFlag = true;
    }
    this.setFilterForm();
    this.initialFlag = true;
    this._showLoader();
    if (this.configObject) this.formDataFields();
    sessionStorage.removeItem(AppSettings.ASSET_FILTER_STRING);
    sessionStorage.removeItem('assetsGalleryIdsList');
    this.removedCheckedAssetsSubscription = this.removedCheckedAssets?.subscribe((result) => {
      if (result._id) {
        const idx = this.assetChecked.findIndex((el) => el._id === result._id);
        if (idx != -1) {
          this.assetChecked.splice(idx, 1);
        }
      }
    });
    this.skipFilterProperty = ['createProject', 'createStepper'].includes(this.configObject?.callFrom)
      ? ['client', 'brand']
      : [AssetMetadata.General.TAGS, 'searchText'];
    switch (this.configObject && this.configObject?.callFrom) {
      case 'dashboard': {
        this.dashboardFlag = true;
        this.filterObject['limit'] = this.configObject?.noOfItems;
        this.fetchMore(null, null, true);
        this.enableAssetDetailsLink = true;
        break;
      }
      case 'createProject':
      case 'createStepper': {
        if (this.configObject?.callFrom === 'createProject') {
          this.hideBulkEdit = true;
        }
        this._showLoader(false);
        this.projectFlag = true;
        this.showUploadBtn = false;
        this.itemSize = 212;
        this.projectFilterSubscription = this.projectFilterData.subscribe((filters: { client: string; brand: string }) => {
          this.projectFilters = filters;
          if (!filters.brand && !filters.client) {
            this.imageSplitObject = [];
            this.showEmptyState = true;
            this._showLoader(false);
            return;
          }
          this.fetchMore(filters, null, true);
        });
        break;
      }
      case 'assetUploadStepper': {
        this.showUploadBtn = false;
        this.hideBulkEdit = true;
        this.fetchMore(null, null, true);
        break;
      }
      default:
        this.fetchMore(null, null, true);
        break;
    }
    this.selectedViewType = this.assetViewTypeService.getViewType(this.gridSettingsKeySuffix);

    // Assets overview page
    if (!this.configObject) {
      this.enableAssetDetailsLink = true;
    }
    this.exportAssetInfoSub = this.assetCommonService.exportAssetInfo.subscribe((data) => {
      if (data) this.exportAssets();
    });
    // customer specific settings
    if (this.brandingKey === CustomClients.Arval) {
      this.setVisibleCustomFields();
      this.filterBubbles = this.filterBubblesObj();
    }
  }

  setFilterForm() {
    this.filterAssetFormData = customerAssetFilters(this.brandingKey) ?? FilterFormData.FORM_DATA;
    const statusField = this.filterAssetFormData.formFields?.find((field) => field.formFieldName === 'status');
    if (statusField?.options.length === 0) {
      if (this.brandingKey == CustomClients.LufthansaMediacenter || this.brandingKey == CustomClients.LufthansaMedialounge) {
        statusField.options = this.assetCommonService.getLufthansaAssetFilterStatusList(this.canPipe, this.AnyAsset);
      } else {
        statusField.options = this.assetCommonService.getAssetFilterStatusList(this.canPipe, this.AnyAsset);
      }
    }
  }

  multiSelectFilter(filter: AnyType) {
    const orSearchTextIndex = this.filterObject['filters']['$or']?.findIndex((or: AnyType) => 'name' in or);
    if (filter && (filter['alignment'] || filter['ageGroup'] || filter['groupOfPeople'])) {
      if (orSearchTextIndex !== undefined && orSearchTextIndex !== -1) {
        this.filterObject['filters'] = {
          ...this.filterObject['filters'],
          $and: [
            {
              $or: [...this.filterObject['filters']['$or']],
            },
            {
              $or: this.filterEmptyObjects([
                { ...this.multiFilterData(filter['alignment'], 'alignment') },
                { ...this.multiFilterData(filter['ageGroup'], 'ageGroup') },
                { ...this.multiFilterData(filter['groupOfPeople'], 'groupOfPeople') },
              ]),
            },
          ],
        };
      } else {
        this.filterObject['filters'] = {
          ...this.filterObject['filters'],
          $and: [
            {
              $or: this.filterEmptyObjects([
                { ...this.multiFilterData(filter['alignment'], 'alignment') },
                { ...this.multiFilterData(filter['ageGroup'], 'ageGroup') },
                { ...this.multiFilterData(filter['groupOfPeople'], 'groupOfPeople') },
              ]),
            },
          ],
        };
      }
    } else {
      delete this.filterObject['filters']['$and'];
    }
  }

  multiFilterData(filter: { _id: string; name: string }[], objectKey: string) {
    let multiFilter: string[] = [];
    if (filter && Array.isArray(filter)) {
      multiFilter = filter.map((k) => k._id);
      return { [`customFields.${objectKey}`]: { $in: multiFilter } };
    }
    return undefined;
  }

  /**
   * Function to filter out empty objects from the $or array
   */
  filterEmptyObjects(array: AnyType[]) {
    return array.filter((obj) => Object.keys(obj).length > 0);
  }

  fetchMore(filterData?: AnyType, sortData?: AnyType, sortFlag?: boolean, loadMoreFlag?: boolean) {
    if (this.queryStringObject && this.queryStringObject['filterString'] && this.configObject?.callFrom !== 'createProject') {
      const getFilterData = JSON.parse(this.queryStringObject['filterString']);
      if (getFilterData && this.initialFlag) {
        this.appliedFilters = 0;
        // Applied filters count
        this.appliedFilters = this.commonUtilityLib.filterDataCount(getFilterData.selectedFilterData, this.skipFilterProperty);
        // selected filter object: input for filter component
        this.selectedFilterObject = getFilterData.selectedFilterData;
        if (this.selectedFilterObject.tags) this.tagsObj.tags = this.selectedFilterObject.tags;
        this.filterBubbles = this.filterBubblesObj();
        // reassign searched text to ngModel searchText value
        this.searchText = getFilterData.searchedText;
        this.filterObject = getFilterData;
      } else {
        this.setFilterData(filterData, sortData, sortFlag, loadMoreFlag);
      }
    } else {
      this.setFilterData(filterData, sortData, sortFlag, loadMoreFlag);
    }
    this.initialFlag = false;
    if (this.configObject?.callFrom == 'dashboard') {
      this.filterObject['limit'] = this.configObject?.noOfItems;
    }
    this.assetFindAll(loadMoreFlag);
  }

  private setFilterData(filterData?: AnyType, sortData?: AnyType, sortFlag?: boolean, loadMoreFlag?: boolean) {
    if (!loadMoreFlag) {
      this.imageObject = [];
      this.offset = 0;
      this.filterObject['limit'] = 48;
      this.filterObject['skip'] = 0;
    }
    if (filterData) {
      delete this.filterObject['filters']['brand.name'];
      this.filterObject['filters']['brand.name'] = filterData['brand'] ? (filterData['brand'].name ?? filterData['brand']) : undefined;
      this.filterObject['filters']['client.name'] = filterData['client'] ? (filterData['client'].name ?? filterData['client']) : undefined;
      this.filterObject['filters']['searchText'] = filterData['searchText'] ? (filterData['searchText'].name ?? filterData['searchText']) : undefined;
      this.filterObject['filters']['plannedDeletion'] = filterData['plannedForDeletion'] ? { $exists: true, $ne: null } : undefined;
      let statusIDs = [];
      if (filterData['status'] && (filterData['status']._id || filterData['status'].id)) {
        statusIDs = [filterData['status']._id || filterData['status'].id];
      } else if (filterData['status'] && filterData['status'].length) {
        statusIDs = filterData['status'].map((status: AnyType) => status.id);
      }
      this.filterObject['filters']['status'] = statusIDs && statusIDs.length > 0 ? { $in: statusIDs } : undefined;

      // re-apply the asset type filter to use the id and not the name or objects
      delete this.filterObject['filters']['assetType'];
      if (Array.isArray(filterData['assetType'])) {
        this.filterObject['filters']['assetType'] = filterData['assetType'].map((assetType: AnyType) => assetType.id);
      } else if (filterData['assetType']) {
        this.filterObject['filters']['assetType'] = typeof filterData['assetType'] === 'string' ? filterData['assetType'] : filterData['assetType'].id;
      }

      this.filterObject['filters'][AssetMetadata.General.TAGS] =
        filterData[AssetMetadata.General.TAGS] && filterData[AssetMetadata.General.TAGS].length
          ? { $all: filterData[AssetMetadata.General.TAGS].map((tag: AnyType) => tag._id) }
          : undefined;

      this.dateFilters(filterData);

      this.customFieldsFilters(filterData);

      this.buyoutRightsFilters(filterData);

      /************/
    }
    if (!filterData) {
      this.filterObject['filters'] = {};
      this.filterObject['selectedFilterData'] = {};
    }
    if (sortFlag) {
      this.filterObject['sort'] = sortData || this.defaultSort;
    }

    if (!this.filterObject['filters']['status']) {
      const statusList = this.assetCommonService.getAssetStatusList(this.canPipe, this.AnyAsset);
      this.filterObject['filters']['status'] = {
        $in: statusList,
      };
      // will be enhance later when we have user's role based status
      if (this.brandingKey === CustomClients.Arval) {
        this.filterObject['filters']['status']['$in'].push(Asset.StatusEnum.Pending);
      }
    }

    // Clean filtered data and store it in a separate query string
    const selectedFilterData: AnyType = filterData ? Object.fromEntries(Object.entries(filterData).filter(([_, v]) => v && v != '')) : {};
    if (this.brandingKey === CustomClients.Vorwerk) {
      this.assetFiltersService.multiSelectFilterVorwerk(this.filterObject, selectedFilterData);
    }
    if (this.brandingKey === CustomClients.LufthansaMediacenter) {
      this.assetFiltersService.multiSelectFilterLufthansa(this.filterObject, filterData);
    }
    for (const key in selectedFilterData) {
      if (selectedFilterData[key]._id || selectedFilterData[key].id) {
        selectedFilterData[key] = {
          _id: selectedFilterData[key]._id || selectedFilterData[key].id,
          name: selectedFilterData[key].name,
        };
      }
    }
    this.selectedFilterObject = selectedFilterData;
    this.filterBubbles = this.filterBubblesObj();
    this.appliedFilters = this.commonUtilityLib.filterDataCount(selectedFilterData, this.skipFilterProperty);
    const tempFilterObject = { ...this.filterObject, selectedFilterData, searchedText: this.searchText };
    tempFilterObject['skip'] = 0;
    if (!this.configObject || this.configObject?.callFrom !== 'dashboard') {
      sessionStorage.setItem(AppSettings.ASSET_FILTER_STRING, JSON.stringify(tempFilterObject));
    }
  }

  /**
   * Update this.filterObject with buyout filters
   * @param filterData
   */
  buyoutRightsFilters(filterData?: AnyType) {
    this.filterObject['filters']['usageRights.creatorDepartment'] = this.filterObj(filterData['creatorDepartment']);
    this.filterObject['filters']['usageRights.buyoutRightsTitle'] = this.filterObj(filterData['buyout']);
    this.filterObject['filters']['usageRights.buyoutRights.licenseRegion'] = this.filterObj(filterData['licenseRegion']);
  }

  /**
   * Construct $in filter object
   * @param filters
   * @returns
   */
  filterObj(filters: AnyType) {
    if (filters && filters.length) {
      return { $in: filters.map((filter: AnyType) => filter._id) };
    }
    return undefined;
  }

  /**
   * Create search filter, add it to query string and call asset find all api
   */
  private searchTextFilter() {
    this.searchText = this.searchText?.trim();
    if (!this.configObject || this.configObject?.callFrom !== 'dashboard') {
      const searchTextObj = this.searchText ? { searchText: { _id: this.searchText, name: this.searchText } } : {};
      const tempFilterObject = { ...this.filterObject, selectedFilterData: searchTextObj, searchedText: this.searchText, skip: 0 };
      sessionStorage.setItem(AppSettings.ASSET_FILTER_STRING, JSON.stringify(tempFilterObject));
    }
    this.assetFindAll();
  }

  assetFindAll(loadMoreFlag?: boolean, config: { silent: boolean } = { silent: false }): Promise<AnyType> {
    return new Promise((resolve, reject) => {
      this.assetService
        .assetsControllerFindAll(this.searchText, JSON.stringify(this.filterObject))
        .pipe(tap(() => this._showLoader(false)))
        .subscribe({
          next: async (response) => {
            const oldImageObject = [...this.imageObject];
            if (!loadMoreFlag) {
              this.imageObject = [];
            }
            this.assetCount = response.count;
            this.loading = false;
            const basketIDs = this.assetBasketService.assetIdsFromMyBasket;
            const responseData = this.assetUrlService.generatePreview(response.result ?? []);
            for (const asset of responseData) {
              asset['isAddedToBasket'] = basketIDs.includes(asset._id);
              asset['assetExpiryDays'] = this.assetCommonService.getAssetExpireDays(asset.expiryDate);
            }

            timer(100).subscribe(() => {
              if (this.scrollFlag) {
                this.loading = false;
              } else {
                this.loading = true;
              }

              const newImageObject = [...this.imageObject, ...responseData] as AssetUIModel[];

              if (config.silent) {
                resolve(newImageObject);
                this.imageObject = oldImageObject;
                return;
              }

              this.imageObject = [...newImageObject];
              if (this.configObject?.callFrom === 'assetUploadStepper') {
                this.imageObject = this.imageObject.filter((asset: AssetUIModel) => {
                  return !this.excludedAssets?.includes(asset._id);
                });
              }
              if (this.dashboardFlag) {
                this.size = this.configObject?.itemSize;
              }
              this.imageSplitObject = [];
              this.imageSplitObject = this.split(this.imageObject, this.size);
              this.showEmptyState = !this.imageSplitObject || this.imageSplitObject.length === 0;
              if (!this.dashboardFlag && !['createProject', 'assetUploadStepper'].includes(this.configObject?.callFrom)) {
                this.commonUtilityLib.emitNewHeaderline($localize`Asset overview: ${this.assetCount}`);
              }
              if (this.scrollFlag) {
                this.ngAfterViewInit();
              }

              resolve(this.imageObject);
            });
          },
          error: (err) => {
            this.clientNotificationHandlerService.errorNotification(err);
            reject(err);
          },
        });
    });
  }

  customFieldsFilters(filterData?: AnyType) {
    /* set filterObject for Arval client */
    if (this.brandingKey === CustomClients.Arval) this.multiSelectFilter(filterData);
    this.filterObject['filters']['customFields.subject'] = filterData['subject'] ? filterData['subject']._id : undefined;
    this.filterObject['filters']['customFields.product'] = filterData['product'] ? filterData['product']._id : undefined;
    this.filterObject['filters']['customFields.channel'] = filterData['channel'] ? filterData['channel']._id : undefined;
    this.filterObject['filters']['customFields.subcategory'] = filterData['subcategory'] ? filterData['subcategory']._id : undefined;
    this.filterObject['filters']['customFields.type'] = filterData['type'] ? filterData['type']._id : undefined;
    this.filterObject['filters']['mainFile.ext'] = filterData['fileType'] ? filterData['fileType'].id : undefined;
  }

  dateFilters(filterData?: AnyType) {
    const validUntil = filterData['expiryDate'] ? filterData['expiryDate'] : '';
    if (validUntil && validUntil !== '') {
      this.filterObject['filters']['expiryDate'] = { $lte: validUntil };
    } else if (this.filterObject['filters']['expiryDate']) {
      delete this.filterObject['filters']['expiryDate'];
    }

    const createdDate_from = filterData['createdDate_from'] ? filterData['createdDate_from'] : '';
    const createdDate_to = filterData['createdDate_to'] ? filterData['createdDate_to'] : '';
    const expiryDate_from = filterData['expiryDate_from'] ? filterData['expiryDate_from'] : '';
    const expiryDate_to = filterData['expiryDate_to'] ? filterData['expiryDate_to'] : '';
    const plannedForDeletion_from = filterData['plannedForDeletion_from'] ? filterData['plannedForDeletion_from'] : '';
    const plannedForDeletion_to = filterData['plannedForDeletion_to'] ? filterData['plannedForDeletion_to'] : '';
    const publishedDate_from = filterData['publishedDate_from'] ? filterData['publishedDate_from'] : '';
    const publishedDate_until = filterData['publishedDate_until'] ? filterData['publishedDate_until'] : '';

    this.constructDateFilter(createdDate_from, createdDate_to, 'createdAt');
    this.constructDateFilter(expiryDate_from, expiryDate_to, 'expiryDate');
    this.constructDateFilter(plannedForDeletion_from, plannedForDeletion_to, 'plannedDeletion');
    this.constructDateFilter(publishedDate_from, publishedDate_until, 'publishStartDate');
    this.constructDateFilter(publishedDate_from, publishedDate_until, 'publishEndDate');
  }

  constructDateFilter(dateFrom: AnyType, dateTo: AnyType, dateKey: string) {
    if (dateFrom) {
      if (!this.filterObject['filters'][dateKey]) {
        this.filterObject['filters'][dateKey] = {};
      }
      this.filterObject['filters'][dateKey]['$gte'] = dateFrom;
    }
    if (dateTo) {
      if (!this.filterObject['filters'][dateKey]) {
        this.filterObject['filters'][dateKey] = {};
      }
      this.filterObject['filters'][dateKey]['$lte'] = dateTo;
    }
  }

  download(asset: AssetUIModel) {
    const downloadData = this.downloadAssetsService.createDownloadData([asset]);
    this.dialog.open<AssetDownloadComponent, AssetDownloadData>(AssetDownloadComponent, {
      width: '100%',
      maxWidth: '70rem',
      height: '100%',
      maxHeight: '43rem',
      disableClose: true,
      data: { data: downloadData },
    });
  }

  sortToggle(event?: ViewType) {
    this.sortByNew = !this.sortByNew;
    this.selectedViewSection2 = event || 'sortByLastCreated';
    if (!this.sortByNew) {
      this.sortData = { name: 1 };
    } else {
      this.sortData = this.defaultSort;
    }
    this.filterObject['sort'] = this.sortData;
    if (this.configObject?.callFrom === 'createProject' && !this.projectFilters) return;
    this.assetFindAll();
  }

  updateEvent(event: AnyType, tags: AnyType): AnyType | undefined {
    const hasProjectFilters = this.projectFilters && Object.keys(this.projectFilters).length > 0;
    const hasSearchText = this.searchText && this.searchText.trim().length > 0;

    if (event || hasProjectFilters || tags || hasSearchText) {
      const updatedEvent = {
        ...(event || {}),
        ...(hasProjectFilters ? this.projectFilters : {}),
        ...(tags || {}),
      };
      if (hasSearchText) {
        updatedEvent['searchText'] = { _id: this.searchText, name: this.searchText };
      }
      return updatedEvent;
    } else {
      return undefined;
    }
  }

  applyFilters(event: AssetUIModel) {
    const tags = this.tagsObj.tags.length ? this.tagsObj : undefined;
    event = this.updateEvent(event, tags);
    const isEmpty = Object.values(event || {}).every((x) => x === null || x === '' || x.length === 0);
    const sortData = Object.keys(this.sortData).length === 0 ? this.defaultSort : this.sortData;
    if (!isEmpty) {
      if (this.configObject?.callFrom === 'createProject' && !this.filterObject['filters']['client.name']) return;
      this.fetchMore(event, sortData, true);
    } else {
      if (this.configObject?.callFrom === 'createProject' && isEmpty) return;
      this.appliedFilters = 0;
      delete this.filterObject['filters']['$or'];
      this.fetchMore(event, sortData, true);
    }
  }
  /**
   * Update form data on filter dropdown change
   * @param event
   */
  updateFormData(event: AnyType) {
    if (event?.formControlName) {
      switch (this.brandingKey) {
        case CustomClients.Arval:
          this.assetCommonService.updateArvalFormData(event.formControlName, this.filterAssetFormData);
          break;
        case CustomClients.Vorwerk: {
          const fieldData = {
            formGroupField: {
              formFields: this.filterAssetFormData.formFields,
            },
            formFieldName: event.formControlName,
            ...event,
          };
          switch (event.formControlName) {
            case 'brand':
              this.productBrandSelectionService.updateOnBrandSelection(
                fieldData,
                this.assetSidebar?.filterForms.filterForm as AbstractControl<AnyType, AnyType>,
              );
              break;
            case 'product':
              this.productBrandSelectionService.updateOnProductSelection(
                fieldData,
                this.assetSidebar?.filterForms.filterForm as AbstractControl<AnyType, AnyType>,
              );
              break;
            case 'plannedForDeletion': {
              const formFields = fieldData.formGroupField.formFields;
              ['plannedForDeletion-label', 'plannedForDeletion_from', 'plannedForDeletion_to'].forEach((item) => {
                const index = formFields.findIndex((field: AnyType) => field.formFieldName === item);
                if (index !== -1) {
                  formFields[index].visible = event.event.checked;
                }
              });
              break;
            }
            case 'status': {
              const isApproved = Array.isArray(fieldData.event.value) ? fieldData.event.value.some((val: AnyType) => val.id === 'approved') : false;
              const formFields = fieldData.formGroupField.formFields;
              ['publishedDate-label', 'publishedDate_from', 'publishedDate_until'].forEach((item) => {
                const index = formFields.findIndex((field: AnyType) => field.formFieldName === item);
                formFields[index].visible = isApproved;
              });
              break;
            }
            case 'agency': {
              if (!event.event.value) {
                const formFields = fieldData.formGroupField.formFields;
                const formFieldIndex = formFields.findIndex((field: AnyType) => field.formFieldName === 'client');
                formFields[formFieldIndex].options = [];
              }
              break;
            }
          }
          break;
        }
      }
    } // handle filter form reset
    else {
      if (this.brandingKey === CustomClients.Arval) this.resetCustomFields(['channel', 'type']);
      if (this.brandingKey === CustomClients.Vorwerk) {
        this.resetCustomFields(['product', 'subcategory']);
        // Hide plan for deletion and published date form field on reset
        this.resetFormFields([
          'plannedForDeletion-label',
          'plannedForDeletion_from',
          'plannedForDeletion_to',
          'publishedDate-label',
          'publishedDate_from',
          'publishedDate_until',
        ]);
      }
    }
  }
  /**
   * Rest custom form field (channel and type)
   */
  resetCustomFields(fields: string[]) {
    // show or hide channel and type based on the patch value
    fields.forEach((item) => {
      this.assetCommonService.findFormFields(item, false, this.filterAssetFormData);
    });
  }

  /**
   * Hide form fields on reset
   * @param fields
   */
  resetFormFields(fields: string[]) {
    fields.forEach((item) => {
      const index = this.filterAssetFormData.formFields.findIndex((field: AnyType) => field.formFieldName === item);
      if (index !== -1) {
        this.filterAssetFormData.formFields[index].visible = false;
      }
    });
  }

  /**
   * Set visible property of channel and type field
   */
  private setVisibleCustomFields() {
    this.filterAssetFormData.formFields.forEach((item) => {
      switch (item.formFieldName) {
        case 'channel': {
          const productIndex = this.commonUtilityLib.findArrayIndex(this.filterAssetFormData, 'product');
          item.visible = !!this.selectedFilterObject?.[this.filterAssetFormData.formFields[productIndex].formFieldName || ''];
          break;
        }
        case 'type': {
          const channelIndex = this.commonUtilityLib.findArrayIndex(this.filterAssetFormData, 'channel');
          item.visible = !!this.selectedFilterObject?.[this.filterAssetFormData.formFields[channelIndex].formFieldName || ''];
          break;
        }
      }
    });
  }

  /**
   * Reset filter form data on menu close from the parent component
   */
  restFormField() {
    this.assetSidebar?.filterForms.resetFormData();
    if (this.brandingKey === CustomClients.Arval) this.setVisibleCustomFields();
  }

  changed() {
    if (this.configObject?.callFrom === 'createProject' && !this.projectFilters) return;
    this.modelChanged.next(this.searchText);
  }

  private split(input: AssetUIModel[], groupSize: number): AssetUIModel[][] {
    const out = [];
    for (let i = 0; i < input.length; i += groupSize) {
      out.push(input.slice(i, i + groupSize));
    }
    return out;
  }

  private detectScreenSize() {
    const currentSize = this.sizes.find((x) => {
      const el = this.elementRef.nativeElement.querySelector(`.${this.prefix}${x.id}`);
      const isVisible = window.getComputedStyle(el).display != 'none';
      return isVisible;
    });
    this.resizeSvc.onResize(currentSize?.id);
  }

  viewAssetTags() {
    delete this.filterObject['filters']['searchText'];
    const filter: AnyType = Object.fromEntries(Object.entries(this.filterObject.filters).filter(([_, v]) => v && v != ''));
    this.tagsDialogRef = this.dialog.open<TagsDialogComponent, TagsDataConfig>(TagsDialogComponent, {
      maxWidth: '40rem',
      width: '50%',
      height: '62%',
      data: {
        selectedTags: this.selectedFilterObject[AssetMetadata.General.TAGS] ? this.selectedFilterObject[AssetMetadata.General.TAGS] : [],
        filters: { ...filter, name: { $regex: this.searchText, $options: 'i' } },
        callFrom: 'dialog',
      },
    });
    this.tagsDialogRef.disableClose = true;
    this.tagsDialogRef.afterClosed().subscribe(async (tags) => {
      if (Array.isArray(tags)) {
        if (tags?.length) {
          this.tagsObj = { tags: tags } as AnyType;
          this.applyFilters({ ...this.selectedFilterObject, ...this.tagsObj });
        } else {
          this.applyFilters({ ...this.selectedFilterObject });
        }
      }
    });
  }

  buyoutRightsConfirmationDialog(uploadedAssets: AssetUIModel[]) {
    this.confirmDialog
      .open({
        title: $localize`Add buyout rights for uploaded assets`,
        message: $localize`You can add buyout rights for individual assets later.`,
        confirmCaption: $localize`:dialog button:Add`,
        confirmCaptionIcon: 'add_box',
        confirmCaptionCssStyle: '!justify-start',
      })
      .pipe(
        switchMap((data) => {
          if (data) {
            return this.buyoutUtilsService.assetBuyoutRightsDialogs(uploadedAssets);
          }
          return EMPTY;
        }),
      )
      .subscribe((update) => {
        if (update) {
          this.assetCommonService.assetDataSubject$.next(update.updatedAsset);
        }
      });
  }

  exportAssets(): void {
    if (!this.showEmptyState) {
      // Download report of the selected assets
      const basketIDs = this.assetBasketService.assetIdsFromMyBasket;
      this.filterObject['filters']['_id'] = {
        $in: basketIDs,
      };
      // filter is the mongo query for mongo.find()
      // filterOptions is the options for mongo.find()
      const filter = JSON.stringify(this.filterObject.filters);
      const process$ = this.exportExcelApiService.exportsControllerExportExcel({ type: ExportExcelRequest.TypeEnum.Assets, filter });
      this.backgroundProcessService.addExportProcess(process$, ExportExcelRequest.TypeEnum.Assets);
    }
  }

  deleteAsset(asset: AssetUIModel, id: string, planDeletionFlag?: boolean) {
    const dialogRef = this.dialog.open(AssetDeletionDialogComponent, { data: { planDeletionFlag: planDeletionFlag } });
    dialogRef.disableClose = true;
    dialogRef
      .afterClosed()
      .pipe(
        tap((data) => {
          if (data?.confirm) {
            switch (data.actionType) {
              case 'planDeletion': {
                this.assetCommonService.plannedForDeletion(id, data.plannedDeletionObj || {}, data.deletionDate || '');
                break;
              }
              case 'deleteAsset': {
                this.assetsRemoveMultiple(asset, id);
                break;
              }
            }
          }
        }),
      )
      .subscribe();
  }

  /**
   * Delete asset functionality
   * @param asset
   * @param id
   */
  assetsRemoveMultiple(asset: AssetUIModel, id: string) {
    this.assetService.assetsControllerRemoveMultiple(true, { assetIds: [id] }).subscribe({
      next: (res) => {
        if (res.status === 'success') {
          this.clientNotificationHandlerService.successNotification($localize`Asset deleted successfully`);
          this.imageObject = this.imageObject.filter((asset: AssetUIModel) => asset._id !== id);
          this.imageSplitObject = [];
          this.imageSplitObject = this.split(this.imageObject, this.size);
          this.showEmptyState = !this.imageSplitObject || this.imageSplitObject.length === 0;
          // update the basket local storage if asset got deleted
          if (asset['isAddedToBasket']) {
            this.addRemoveFromBasket(asset, true);
          }
          if (!this.dashboardFlag && this.configObject?.callFrom !== 'createProject') {
            this.assetCount = this.assetCount - 1;
            this.commonUtilityLib.emitNewHeaderline($localize`Asset overview: ${this.assetCount}`);
          }
        } else {
          this.notificationsService.addNotification({
            type: 'failure',
            message: res.details.length ? res.details[0].status : $localize`Something went wrong`,
          });
        }
      },
      error: (err) => this.clientNotificationHandlerService.errorNotification(err),
    });
  }

  /**
   * Add or remove from basket
   * @param asset
   */
  addRemoveFromBasket(asset: AssetUIModel, allChecked?: boolean) {
    if (this.configObject?.emitSelectedAssets) {
      if (asset.checked) {
        asset.checked = false;
        const index = this.assetChecked.findIndex((el) => el._id === asset._id);
        if (index !== -1) {
          this.assetChecked.splice(index, 1);
        }
      } else {
        asset.checked = true;
        const assetExists = this.assetChecked.find((el) => el._id === asset._id);
        if (!assetExists) {
          this.assetChecked.push(asset);
        }
      }

      return;
    }

    if (asset['isAddedToBasket']) {
      this.assetBasketService.removeFromBasket(asset._id);
    } else {
      this.assetBasketService.addToBasket(asset._id);
    }
    asset['isAddedToBasket'] = !asset['isAddedToBasket'];
    if (!allChecked) {
      this.updateSelectedItems('assets', [asset], allChecked ? allChecked : false);
    }
  }

  sortAssets(event?: AnyType) {
    if (event) {
      this.filterObject['sort'] = event;
    }
    this.assetFindAll();
  }

  addOnEnter() {
    if (this.searchText) {
      const searchBubble = { _id: this.searchText, name: this.searchText };
      this.applyFilters({ ...this.selectedFilterObject, searchText: searchBubble });
    } else {
      this.applyFilters({ ...this.selectedFilterObject });
    }
  }

  /**
   * Create a array of object for filter bubbles
   * @returns
   */
  private filterBubblesObj(): { _id: string; name: string; key: string }[] {
    if (!this.selectedFilterObject || this.commonUtilityLib.isEmptyObject(this.selectedFilterObject)) return [];
    return Object.keys(this.selectedFilterObject)
      .map((key) => {
        const filterFormField = this.filterAssetFormData?.formFields;
        const fieldIndex = filterFormField?.findIndex((field) => field.formFieldName === key);
        const fieldLabel = fieldIndex !== -1 ? this.filterAssetFormData?.formFields[fieldIndex].fieldLabel : '';
        if (fieldIndex !== -1 && this.filterAssetFormData?.formFields[fieldIndex].multiple) {
          return this.selectedFilterObject[key].map((obj: AnyType) => ({ _id: obj._id ?? obj.id, name: `${fieldLabel}: ${obj.name}`, key }));
        } else {
          switch (key) {
            case 'expiryDate':
            case 'createdAt': {
              return {
                _id: key,
                name: `${fieldLabel}: ${this.spDatePipe.transform(this.selectedFilterObject[key].toString())}`,
                key,
              };
            }
            case 'createdDate_from':
            case 'createdDate_to':
            case 'expiryDate_from':
            case 'expiryDate_to':
            case 'plannedForDeletion_from':
            case 'plannedForDeletion_to':
            case 'publishedDate_until':
            case 'publishedDate_from': {
              const dateLabel = FilterBubbleDateLabel[key];
              return {
                _id: key,
                name: `${dateLabel}: ${this.datePipe.transform(this.selectedFilterObject[key].toString(), 'dd.MM.yyyy')}`,
                key,
              };
            }
            case AssetMetadata.General.TAGS: {
              return this.selectedFilterObject[key].map((obj: AnyType) => ({ _id: obj._id, name: obj.name, key }));
            }
            case 'searchText': {
              return {
                _id: this.selectedFilterObject[key].name,
                name: this.selectedFilterObject[key].name,
                key,
              };
            }
            default: {
              return {
                _id: key,
                name: `${fieldLabel}: ${this.selectedFilterObject[key].name || this.selectedFilterObject[key]}`,
                key,
              };
            }
          }
        }
      })
      .flat(1); // added this flat because tags key value is coming as array
  }

  /**
   * Update filter bubbles when removed
   * @param filterBubble
   * @param key
   * @param filterBubblesIndex
   */
  updateBubbles(filterBubble: { _id: string; name: string; key: string }, key: string, filterBubblesIndex: number) {
    const filterIndex = this.selectedFilterObject[key]?.findIndex((key: AnyType) => key._id === filterBubble._id);
    if (filterIndex !== -1) {
      this.filterBubbles.splice(filterBubblesIndex, 1);
      this.selectedFilterObject[key].splice(filterIndex, 1);
      if (this.selectedFilterObject[key].length === 0) delete this.selectedFilterObject[key];
      this.fetchMore(this.selectedFilterObject);
    }
  }

  /**
   * Remove single filer bubble
   * @param filterBubble
   */
  removeFilterBubble(filterBubble: { _id: string; name: string; key: string }) {
    const filterBubblesIndex = this.filterBubbles.findIndex((filter) => filter._id === filterBubble._id);
    this.formResetter.next(filterBubble);
    if (filterBubblesIndex !== -1) {
      switch (filterBubble.key) {
        case 'client': {
          if ('brand' in this.selectedFilterObject) {
            const brandIndex = this.filterBubbles.findIndex((filter) => filter._id === 'brand');
            delete this.selectedFilterObject['brand'];
            this.filterBubbles.splice(brandIndex, 1);
          }
          delete this.selectedFilterObject[filterBubble._id];
          this.filterBubbles.splice(filterBubblesIndex, 1);
          this.fetchMore(this.selectedFilterObject);
          return;
        }
        case AssetMetadata.General.TAGS:
        case 'alignment':
        case 'ageGroup':
        case 'groupOfPeople': {
          this.updateBubbles(filterBubble, filterBubble.key, filterBubblesIndex);
          return;
        }
        case 'searchText': {
          this.filterBubbles.splice(filterBubblesIndex, 1);
          delete this.selectedFilterObject[filterBubble.key];
          this.searchText = '';
          this.fetchMore(this.selectedFilterObject);
          return;
        }
        default: {
          this.filterBubbles.splice(filterBubblesIndex, 1);
          if (Array.isArray(this.selectedFilterObject[filterBubble.key])) {
            const filterIndex = this.selectedFilterObject[filterBubble.key].findIndex((filter: AnyType) => (filter.id || filter._id) === filterBubble._id);
            if (filterIndex !== -1) this.selectedFilterObject[filterBubble.key].splice(filterIndex, 1);
            if (this.selectedFilterObject[filterBubble.key].length === 0) delete this.selectedFilterObject[filterBubble.key];
          } else {
            delete this.selectedFilterObject[filterBubble._id];
          }
          this.fetchMore(this.selectedFilterObject);
          return;
        }
      }
    }
    if (this.brandingKey === CustomClients.Arval) this.setVisibleCustomFields();
  }

  /**
   * Clear all filter bubbles
   */
  removeAllFilterBubble() {
    this.selectedFilterObject = {};
    this.tagsObj.tags = [];
    this.searchText = '';
    if (!this.assetSidebar?.filterForms) this.fetchMore();
    this.formResetter.next(undefined);
    if (this.brandingKey === CustomClients.Arval) this.setVisibleCustomFields();
  }

  ngOnDestroy(): void {
    this.resizeSubscription?.unsubscribe();
    this.projectFilterSubscription?.unsubscribe();
    this.removedCheckedAssetsSubscription?.unsubscribe();
    this.modelSub?.unsubscribe();
    this.exportAssetInfoSub?.unsubscribe();
  }

  /**
   * Utility method to show/hide loader
   */
  private _showLoader(show = true) {
    this.httpCallInProgress = show;
  }

  /**
   * SearchField methods
   */

  searchTextChanged(event: AnyType) {
    if (event) {
      this.searchText = event;
      if (this.configObject?.callFrom === 'createProject' && !this.projectFilters) return;
      this.modelChanged.next(this.searchText);
    } else {
      this.clearSearch(event);
    }
  }

  clearSearch(event: AnyType) {
    this.removeFilterBubble({ _id: this.searchText, name: this.searchText, key: 'searchText' });
    this.searchText = event;
    this.searchTextFilter();
  }

  toggleMobileSearch() {
    this.isMobileSearchOpen = !this.isMobileSearchOpen;
    if (this.isMobileSearchOpen) {
      document.querySelector('.actions-container')?.classList.remove('mb-8');
    }
    if (!this.isMobileSearchOpen) {
      document.querySelector('.actions-container')?.classList.add('mb-8');
    }
  }

  onEvent(event: AnyType) {
    this.isMobileSearchOpen = false;
    document.querySelector('.actions-container')?.classList.add('mb-8');
  }

  initAssetView() {
    const gridSettings = this.assetViewTypeService.getGridConfig(this.gridSettingsKeySuffix);

    if (Object.keys(gridSettings).length) {
      this.gridConfig = gridSettings;
      return;
    }

    // set customer additional settings
    if (this.brandingKey === CustomClients.Vorwerk) {
      this.gridConfig.showGridViewSmall = false;
      this.gridConfig.showGridViewLarge = true;
    }
    this.assetViewTypeService.setGridConfig(this.gridSettingsKeySuffix, this.gridConfig);
  }

  private setAssetView(currentSize?: AnyType) {
    const gridSettings = this.assetViewTypeService.getGridConfig(this.gridSettingsKeySuffix);
    if (gridSettings.showGridViewLarge && !gridSettings.showGridViewSidebar) {
      this.size = 8;
      if (currentSize?.name === 'xl') this.size = 8;
      if (currentSize?.name === 'lg') this.size = 8;
      if (currentSize?.name === 'md') this.size = 4;
    }
    if (gridSettings.showGridViewSmall && !gridSettings.showGridViewSidebar) {
      this.size = 4;
      if (currentSize?.name === 'lg') this.size = 3;
      if (currentSize?.name === 'md') this.size = 2;
    }
    if (gridSettings.showGridViewSidebar && gridSettings.showGridViewSmall) {
      this.size = 3;
      if (currentSize?.name === 'xl') this.size = 3;
      if (currentSize?.name === 'lg') this.size = 2;
      if (currentSize?.name === 'md') this.size = 1;
    }
    if (gridSettings.showGridViewSidebar && gridSettings.showGridViewLarge) {
      this.size = 6;
      if (currentSize?.name === 'xl') this.size = 6;
      if (currentSize?.name === 'lg') this.size = 6;
      if (currentSize?.name === 'md') this.size = 4;
    }
  }

  changeAssetView(view: ViewType, toggle?: boolean) {
    if (view !== 'list') {
      this.gridConfig.showListView = false;
      this.gridConfig.showGridView = true;

      if (view === 'grid_4') {
        this.gridConfig.showGridViewSmall = true;
        this.gridConfig.showGridViewLarge = false;
        this.gridConfig.showGridViewSidebar = false;
        this.selectedViewType = 'grid_4';
        this.size = 4;
      }
      if (view === 'grid_8') {
        this.gridConfig.showGridViewSmall = false;
        this.gridConfig.showGridViewLarge = true;
        this.gridConfig.showGridViewSidebar = false;
        this.selectedViewType = 'grid_8';
        this.size = 8;
        this.itemSize = 155;
      }
      if (view === 'grid_3') {
        this.gridConfig.showGridViewSmall = true;
        this.gridConfig.showGridViewLarge = false;
        this.gridConfig.showGridViewSidebar = true;
        this.selectedViewType = 'grid_3';
        this.size = 3;
      }
      if (view === 'grid_6') {
        this.gridConfig.showGridViewSmall = false;
        this.gridConfig.showGridViewLarge = true;
        this.gridConfig.showGridViewSidebar = true;
        this.selectedViewType = 'grid_6';
        this.size = 6;
      }
      this.assetViewTypeService.setGridConfig(this.gridSettingsKeySuffix, this.gridConfig); // must be called before setAssetView
      this.setAssetView(this.currentSize);
      this.imageSplitObject = [];
      this.imageSplitObject = this.split(this.imageObject, this.size);
    } else if (view === 'list') {
      this.gridConfig.showGridView = false;
      this.gridConfig.showGridViewSmall = false;
      this.gridConfig.showGridViewLarge = false;
      this.gridConfig.showListView = true;
      this.gridConfig.showGridViewSidebar = toggle || false;
      this.selectedViewType = 'list';
      this.assetViewTypeService.setGridConfig(this.gridSettingsKeySuffix, this.gridConfig);
    }
  }

  selectAll(checked: boolean) {
    if (this.assetCount > 500) {
      this.filterObject.limit = 500;
    } else {
      this.filterObject.limit = this.assetCount;
    }
    this.assetFindAll(false, { silent: false }).then((assetList) => {
      if (checked) {
        const addToBasket = assetList.filter((asset: AssetUIModel) => !asset['isAddedToBasket']);
        addToBasket.forEach((asset: AssetUIModel) => {
          this.addRemoveFromBasket(asset, checked);
        });
      } else {
        const removeFromBasket = assetList.filter((asset: AssetUIModel) => asset['isAddedToBasket']);
        removeFromBasket.forEach((asset: AssetUIModel) => {
          this.addRemoveFromBasket(asset, checked);
        });
      }
      this.updateSelectedItems('assets', assetList, checked);
    });
  }

  updateSelectedItems(type: string, assets: AnyType, checked: boolean) {
    const selectedItems = JSON.parse(sessionStorage[AppSettings.SESSION_STORAGE_KEY]);
    const currentTypeIndex = selectedItems.findIndex((obj: { type: string }) => obj.type === type);
    assets.forEach((asset: AssetUIModel) => {
      const itemIndex = selectedItems[currentTypeIndex].items.findIndex((item: AnyType) => item._id === asset._id);
      if (asset.isAddedToBasket && itemIndex === -1) {
        selectedItems[currentTypeIndex].items.push(asset);
      } else {
        const itemsFiltered = selectedItems[currentTypeIndex].items.filter((item: AnyType) => {
          return item._id !== asset._id;
        });
        selectedItems[currentTypeIndex].items = itemsFiltered;
      }
    });
    if (checked) {
      selectedItems[currentTypeIndex].selectedAll = true;
    } else {
      selectedItems[currentTypeIndex].selectedAll = false;
    }

    sessionStorage.setItem(AppSettings.SESSION_STORAGE_KEY, JSON.stringify(selectedItems));
  }

  onAssetScroll($event: { offset: number; direction?: string; anchorIndex?: number }) {
    this.offset = $event.offset;
    this.assetFindAll(true);
  }

  /**
   * Whether the user has access to bulk edit
   */
  bulkEditAccessibility() {
    return (
      this.canPipe.transform(this.AnyAsset, 'delete') ||
      this.canPipe.transform(this.AnyAsset, 'download') ||
      this.canPipe.transform(this.AnyAsset, 'share') ||
      this.canPipe.transform(this.AnyAsset, 'basket.access') ||
      this.canPipe.transform(this.AnyAsset, 'collection.create')
    );
  }

  fileListSelection(event: AnyType) {
    this.assetChecked = event;
    this.selectedAssets.emit(event);
  }

  toggleSidebar() {
    const gridConfig: GridConfig = this.assetViewTypeService.getGridConfig(this.gridSettingsKeySuffix);
    if (gridConfig.showGridViewSmall && !gridConfig.showGridViewSidebar) {
      this.changeAssetView('grid_3');
    } else if (gridConfig.showGridViewSmall && gridConfig.showGridViewSidebar) {
      this.changeAssetView('grid_4');
    } else if (gridConfig.showGridViewLarge && !gridConfig.showGridViewSidebar) {
      this.changeAssetView('grid_6');
    } else if (gridConfig.showGridViewLarge && gridConfig.showGridViewSidebar) {
      this.changeAssetView('grid_8');
    } else if (gridConfig.showListView && !gridConfig.showGridViewSidebar) {
      this.changeAssetView('list', true);
    } else if (gridConfig.showListView && gridConfig.showGridViewSidebar) {
      this.changeAssetView('list', false);
    }
  }
}
